export const companyTemplate = (data) => {
    return `<div class="contact-company">
    <div class="flex">
<!--        <img class="contact-company__img" src="${data.img}"/>-->
        <div style="margin-left: 12px; display: flex; flex-direction: column; justify-content: space-between;">
            <div class="contact-company__name" data-i18n="${data.name}"></div>
            <div class="contact-company__contact"><i class="fa fa-phone"></i><span data-content="phone">${data.phone}</span></div>
            <div class="contact-company__contact"><i class="fa fa-envelope"></i><span data-content="email">${data.email}</span></div>
        </div>
    </div>
    <div class="contact-company__divider"></div>
    <div class="contact-company__location">
        <i class="fa fa-map-marker"></i>
        <span class="contact-company__location-text" data-i18n="${data.location}"></span>
    </div>
</div>
            `
}

export const historyTemplate = (data, index: number) => {
    return `<div class="develop-sly__item">
    <div class="develop-sly__img"><img src="images/contactus/history/${data.year}.png"></div>
    <div style="height: 50px"></div>
    <div class="develop-sly__point"></div>
    <div class="develop-sly__title">${data.year} year</div>
    <div class="develop-sly__content" data-i18n="${data.content}"></div>
    ${ index === 0 ? '<div style="margin-top: 10px;"><img src="images/logos/footer-logo.png" alt=""  style="max-height: 24px;width: auto;height: auto;"></div>' : ''}
</div>
    `
}

export const salesTemplate = (data, index: number) => {
    return `
    <div class="gold-medal-content__sly-img-container"><img src="${data.img}"></div>
    `
}